import {createSvgIcon} from '../create-svg-icon';

export const AddToQueueIcon = createSvgIcon(
  <path d="M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z" />
, 'AddToQueueOutlined');
